import * as z from "zod";
import { null as zNull } from "zod";

export const getFreeShippingCodes = {
  name: "getFreeShippingCodes" as const,
  input: zNull(),
  output: z.object({ codes: z.array(z.string()) }),
};
